(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bdf-wholesale-application"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-wholesale-application-form]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-wholesale-application-status]');
    const successDialog = form.closest('.bdf-wholesale-application').querySelector('[data-wholesale-success-dialog]');
    successDialog.querySelectorAll('[data-wholesale-success-close]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => successDialog.close());
    });
    successDialog.addEventListener('click', (dialogEvent) => {
      if (dialogEvent.target === successDialog) successDialog.close();
    });
    button.disabled = true;
    status.textContent = 'Submitting your application…';
    status.dataset.tone = '';
    try {
      const formData = new FormData(form);
      const payloadBody = Object.fromEntries(formData.entries());
      ['agreesInformationAccurate', 'agreesPrivacyPolicy', 'understandsApproval'].forEach((name) => {
        payloadBody[name] = form.elements[name].checked;
      });
      const response = await fetch(form.action, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payloadBody)
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload.ok || !payload.created) throw new Error(payload.message || 'Unable to submit your application.');
      form.reset();
      status.textContent = 'Thank you. Our wholesale team will review your application within 1–3 business days.';
      status.dataset.tone = 'success';
      successDialog.showModal();
    } catch (error) {
      status.textContent = error.message || 'Unable to submit your application. Please try again.';
      status.dataset.tone = 'error';
    } finally { button.disabled = false; }
  });
});

  } catch(e) { console.error(e); }
})();
})();
